export default function PdfIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      className={className}
    >
      <path
        d="M6 2h9l5 5v15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <text x="7" y="18" fontSize="4.5" fill="currentColor">
        PDF
      </text>
    </svg>
  );
}
